<template>
  <div>
    <main-nav></main-nav>
    <sidebar></sidebar>
    <div class="app-wrapper">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import io from "socket.io-client";
import MainNav from "../components/Layouts/MainNav.vue";
import Sidebar from "../components/Layouts/Sidebar.vue";
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Home",

  components: { MainNav, Sidebar },

  data() {
    return {
      isLoading: true,
    };
  },
  computed: {
    // START:: VUEX GET AUTHENTICATED USER DATA
    ...mapGetters("auth_module", ["currentUser"]),
    // END:: VUEX GET AUTHENTICATED USER DATA
    chats() {
      return this.$store.getters["chat_module/chats"];
    },
    user() {
      return this.$store.getters["auth_module/currentUser"];
    },
  },
  methods: {
    // launch_resize_dispatch() {
    //   this.$store.dispatch("sideNav_module/onResize");
    // },
    ...mapActions({}),
    setMessage(payload) {
      var audio = document.createElement("AUDIO");
      document.body.appendChild(audio);
      if (payload) {
        audio.src = require("@/assets/sounds/notifications.wav");
        audio.play();
        // title: this.$t("newMessage"),
        // message: `${this.$t(payload.data.sender)} `,
        this.$iziToast.show({
          balloon: true,
          displayMode: 2,
          timeout: 15000,
          title: this.$t("newMessage"),
          message: payload.new_notification.body,
        });
      }
    },
    allChatSoket() {
      let socket = io(process.env.VUE_APP_BASE_SOCKET_URL);
      socket.on(
        `dashboard_notification:${localStorage.getItem(
          "Creative_System_Dash_User_Id"
        )}`,
        (payload) => {
          console.log("payload ==> ", payload);
          if (payload) {
            // var audio = document.createElement("AUDIO");
            // document.body.appendChild(audio);
            // audio.src = require("@/assets/sounds/notification.wav");
            // audio.play();
            // this.$iziToast.show({
            //     title: payload.new_notification.title,
            //     message: payload.new_notification.body,
            //   });
            this.setMessage(payload);
            let dataToPush = {
              data_id: payload.new_notification.data_id,
              body: payload.new_notification.body,
              title: payload.new_notification.title,
            };
            console.log("dataToPush ==>", dataToPush);
            this.$store.commit(
              "notifications_module/pushNotification",
              dataToPush
            );
            this.$store.commit(
              "notifications_module/setUnread",
              payload.notification_count
            );
          }
        }
      );
    },
    getPermissions() {
      this.axios
        .get("get_my_permissions", { params: { internal: 1 } })
        .then((res) =>
          localStorage.setItem(
            "alamiya_permissions",
            JSON.stringify(res.data.data)
          )
        );
    },
    getControls() {
      this.axios
        .get("get_my_control_permissions", { params: { internal: 1 } })
        .then((res) =>
          localStorage.setItem(
            "alamiya_controls",
            JSON.stringify(res.data.data)
          )
        );
    },
  },
  created() {
    if (this.user.usertype != "superadmin") {
      this.getPermissions();
      this.getControls();
    } else {
      if (localStorage.getItem("alamiya_controls")) {
        localStorage.removeItem("alamiya_controls");
      }
      if (localStorage.getItem("alamiya_permissions")) {
        localStorage.removeItem("alamiya_permissions");
      }
    }
  },
  mounted() {
    // ===> check if the page is login
    // this.launch_resize_dispatch();
    // if (this.$store.getters.resizeEventExisit == false) {
    //   window.addEventListener("resize", this.launch_resize_dispatch, true);
    //   this.$store.commit("changeRessizeEvent");
    // }
    this.$store.dispatch("notifications_module/getNotifications");
    // this.allChatSoket();
  },
};
</script>
